// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
li[data-v-c7dd0066] {
    position: relative;
    margin-bottom: 2rem;
    clear: both;
    counter-increment: instruction-counter;
    cursor: pointer;
    padding-inline-start: calc(36px + 1rem);
    white-space: pre-line;
}
li[data-v-c7dd0066]::before {
    position: absolute;
    top: 0;
    width: 36px;
    height: 36px;
    border: 1px solid var(--color-border-dark);
    border-radius: 50%;
    background-color: var(--color-background-dark);
    background-position: center;
    background-repeat: no-repeat;
    content: counter(instruction-counter);
    inset-inline-start: 0;
    line-height: 36px;
    outline: none;
    text-align: center;
}
li[data-v-c7dd0066]:hover::before {
    border-color: var(--color-primary-element);
}
.done[data-v-c7dd0066]::before {
    content: '✔';
}
li span[data-v-c7dd0066],
li input[type='checkbox'][data-v-c7dd0066] {
    display: inline-block;
    width: 1rem;
    height: auto;
    padding: 0;
    margin: 0 0.5rem 0 0;
    line-height: 1rem;
    vertical-align: middle;
}
.markdown-instruction[data-v-c7dd0066] ol > li {
    list-style-type: numbered;
}
.markdown-instruction[data-v-c7dd0066] ul > li {
    list-style-type: disc;
}
.markdown-instruction[data-v-c7dd0066] ol > li,
.markdown-instruction[data-v-c7dd0066] ul > li {
    margin-inline-start: 20px;
}
.markdown-instruction[data-v-c7dd0066] a {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeView/RecipeInstruction.vue"],"names":[],"mappings":";AAmCA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,sCAAA;IACA,eAAA;IACA,uCAAA;IACA,qBAAA;AACA;AAEA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,0CAAA;IACA,kBAAA;IACA,8CAAA;IACA,2BAAA;IACA,4BAAA;IACA,qCAAA;IACA,qBAAA;IACA,iBAAA;IACA,aAAA;IACA,kBAAA;AACA;AAEA;IACA,0CAAA;AACA;AAEA;IACA,YAAA;AACA;AAEA;;IAEA,qBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,oBAAA;IACA,iBAAA;IACA,sBAAA;AACA;AAEA;IACA,yBAAA;AACA;AAEA;IACA,qBAAA;AACA;AAEA;;IAEA,yBAAA;AACA;AAEA;IACA,0BAAA;AACA","sourcesContent":["<template>\n    <li :class=\"{ done: isDone }\" @click=\"toggleDone\">\n        <VueShowdown :markdown=\"instruction\" class=\"markdown-instruction\" />\n    </li>\n</template>\n\n<script setup>\nimport { ref } from 'vue';\n\ndefineProps({\n    /* Instruction HTML string to display. Content should be sanitized.\n     */\n    instruction: {\n        type: String,\n        default: '',\n    },\n});\n\n/**\n * @type {import('vue').Ref<boolean>}\n */\nconst isDone = ref(false);\n\nconst toggleDone = () => {\n    isDone.value = !isDone.value;\n};\n</script>\n\n<script>\nexport default {\n    name: 'RecipeInstruction',\n};\n</script>\n\n<style scoped>\nli {\n    position: relative;\n    margin-bottom: 2rem;\n    clear: both;\n    counter-increment: instruction-counter;\n    cursor: pointer;\n    padding-inline-start: calc(36px + 1rem);\n    white-space: pre-line;\n}\n\nli::before {\n    position: absolute;\n    top: 0;\n    width: 36px;\n    height: 36px;\n    border: 1px solid var(--color-border-dark);\n    border-radius: 50%;\n    background-color: var(--color-background-dark);\n    background-position: center;\n    background-repeat: no-repeat;\n    content: counter(instruction-counter);\n    inset-inline-start: 0;\n    line-height: 36px;\n    outline: none;\n    text-align: center;\n}\n\nli:hover::before {\n    border-color: var(--color-primary-element);\n}\n\n.done::before {\n    content: '✔';\n}\n\nli span,\nli input[type='checkbox'] {\n    display: inline-block;\n    width: 1rem;\n    height: auto;\n    padding: 0;\n    margin: 0 0.5rem 0 0;\n    line-height: 1rem;\n    vertical-align: middle;\n}\n\n.markdown-instruction:deep(ol > li) {\n    list-style-type: numbered;\n}\n\n.markdown-instruction:deep(ul > li) {\n    list-style-type: disc;\n}\n\n.markdown-instruction:deep(ol > li),\n.markdown-instruction:deep(ul > li) {\n    margin-inline-start: 20px;\n}\n\n.markdown-instruction:deep(a) {\n    text-decoration: underline;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
